import React from 'react';
import {connect} from 'dva';
import '@/styles/containers/common/wizModalUserIdentityShow/index.less';
import {component_tool, framework_tool} from '@/tool';
import { Table } from "antd";

const {WizCard, WizDataTable, WizTable, WizModal, WizEmpty, WizButton, WizSpin, WizRow, WizCol} = component_tool;
let {WizContainer, modelUtils} = framework_tool;

/**
 * 查看任职
 */
class SelectLinkOrg extends WizContainer {

  componentName = 'SelectLinkOrg';

  constructor(props) {
    super(props);
    this.state = {
      time: new Date().getTime(),
      modalVisible: props.visible,
      personId: null,
      selectedRowKeys : [],
      selectedRows : [],
      resetTime: new Date().getTime(),
      certId : null
    };
    this.personId = null;
    this.orgId = null;
    this.certId = null;
    this.personAndUserInfo = {};
    this.userIdentityInfoList = [];
  }

  getUserPersonInfo() {
    if (this.personId && this.personId != undefined && this.personId != '') {
      this.doAction({
        path: 'certLink/getOrgIdList',
        payload: {
          key: 'getList@' + this.personId,
          apiParams: {
            personId: this.personId,
            certId:this.certId //19
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    personAndUserIdentitiesInfo: this._getListOver.bind(this),
    visible: this._visibleOnChange.bind(this),
    updateOrg : this._updateOrg.bind(this),
  };

  /**
   * 保存
   * @param {*} nextProps
   * @param {*} nextState
   */
  _updateOrg(nextProps, nextStatem) {
    let o = nextProps['updateOrg']

    if (o['success']) {
      wizNotice.success(o['msg']);
    //  this.props.changeModal(false);
      this.doAction({
        path: "certLink/getPageList",
        payload: {
          key: "certLink@list",
          apiParams: {}
        }
      });
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }

  }

  /**
   * 打开模态框时查询数据
   * @param {*} nextProps
   * @param {*} nextState
   */
  _visibleOnChange(nextProps, nextState) {
    nextState['time'] = new Date().getTime();
    const {personId, orgId,certId} = nextProps;
    if (nextProps.visible !== this.state.modalVisible) {
      nextState.modalVisible = nextProps.visible;
      if (nextProps.visible) {
        this.setState({
          personId,
          certId
        });
        this.personId = personId;
        this.orgId = orgId;
        this.certId = certId;
        this.getUserPersonInfo();
      }

    }
    return true
  }

  _userIdentityInfoListOnChange() {
    let personAndUserInfo = this.personAndUserInfo;
    let userIdentityInfoList = [];
    let orgIds = [];
    if (personAndUserInfo ) {
      personAndUserInfo.forEach(userIdentityInfo => {
          const {orgId, id} = userIdentityInfo;
          userIdentityInfo['key'] = id;
          if(!orgIds.includes(orgId)){
            userIdentityInfoList.push(userIdentityInfo)
            orgIds.push(orgId);
            if(orgId===this.props.orgId){
              this.setState({
                selectedRowKeys :[id],
                selectedRows:[userIdentityInfo],
              })
            }
          }
        }
      );

    }
    this.userIdentityInfoList = userIdentityInfoList;
  }

  /**
   * 监控用户信息变化，进行渲染
   */
  _getListOver(nextProps, nextState) {
    let personAndUserIdentitiesInfo = nextProps.personAndUserIdentitiesInfo.data;
    if (nextProps.personAndUserIdentitiesInfo.code == 1 && personAndUserIdentitiesInfo) {
      personAndUserIdentitiesInfo.forEach(val => {
        val.id = val.orgId
      })
      this.personAndUserInfo = personAndUserIdentitiesInfo;
      this._userIdentityInfoListOnChange();
    } else {
      wizNotice.error('获取用户信息失败：' + nextProps.personAndUserIdentitiesInfo.msg);
    }
    return true;
  }


  /**
   * 取消选择
   * @param {*} e
   */
  _onCancel(e) {
    if (this.props.onCancel) {
      this.props.onCancel(e);
      this.setState({
        time: new Date().getTime(),
        personId: null,
      });
    } else {
      this.setState({
        modalVisible: false,
        time: new Date().getTime(),
        personId: null,
      })
    }
    this.personId = null;
    this.orgId = null;
    this.certId = null;
    this.personAndUserInfo = {};
    this.userIdentityInfoList = [];
  }


  _onReset = () => {
    this.setState({ resetTime: new Date().getTime() })
  }

  /**
   * 确认选择
   * @param {*} e
   */
  _onOk(e) {
    let selectedRows = this.state.selectedRows;
    if (selectedRows &&  selectedRows[0]) {
      this.doAction({
        path: 'certLink/updateOrg',
        payload: {
          key: 'updateOrg@',
          apiParams: {
            personId: this.personId,
            id: this.props.id,
            orgId:selectedRows[0]['orgId']
          }
        }
      });
    }
    if (this.props.onCancel) {
      this.props.onCancel(e);
      this.setState({
        time: new Date().getTime(),
        personId: null,
      });
    } else {
      this.setState({
        modalVisible: false,
        time: new Date().getTime(),
        personId: null,
      })
    }
    this.personId = null;
    this.orgId = null;
    this.personAndUserInfo = {};
    this.userIdentityInfoList = [];
  }

  /**
   * 人员基础信息
   * @private
   */
  _userBaseInfo = () => {
    const {userName,fullName,certName,certType} = this.props;
    return (
      <WizCard  className="wizModalUserIdentityShow-card">
        {!true ? <WizEmpty image={WizEmpty.PRESENTED_IMAGE_SIMPLE}/> :
          <>
            {this._renderContentRow('姓名', fullName, '账号', userName)}
            {this._renderContentRow('证书名称', certName, '证书类别', certType ===1 ? '培训证书':'社会证书')}

          </>
        }
      </WizCard>
    )
  };


  _renderContentRow(ln, lv = '', rn, rv = '') {
    return (
      <WizRow className="text_row">
        <WizCol className="text_right" span={3} offset={0.5}>{ln + '：'}</WizCol>
        <WizCol span={6}>{lv}</WizCol>
        <WizCol className="text_right" span={3} offset={2}>{rn + '：'}</WizCol>
        <WizCol span={8}>{rv}</WizCol>
      </WizRow>
    )
  }


  /**
   * 人员任职信息
   * @private
   */
  _userIdentityInfo = () => {
    const {certLinkLoading} = this.props;
    let columns = [
      {
        title: '组织名称',
        dataIndex: 'orgPathName',
        width: '65%',
        key: 'orgPathName',
      },
      {
        title: '组织编码',
        dataIndex: 'orgCode',
        width: '25%',
        key: 'orgCode',
      }];
    //获取需要展示的数据
    let userIdentityInfoList = this.userIdentityInfoList;
    let dataTableProps = {
      loading: false,
      columns,
      dataSource: userIdentityInfoList,
      bordered: false,
      locale: <WizEmpty image={WizEmpty.PRESENTED_IMAGE_SIMPLE}/>,
      tableLayout:'fixed',
      scroll:{
        x:true,
      },
      pagination:{
        position:['bottomCenter']
      },
      rowSelection:{
        type: 'radio',
        selectedRowKeys :this.state.selectedRowKeys ? this.state.selectedRowKeys:[],
        selections:this.state.selectedRows ? this.state.selectedRows:[],
        onChange: (selectedRowKeys, selectedRows) => {
          this.setState({
            selectedRowKeys: selectedRowKeys,
            selectedRows: selectedRows
          })
        }
      }
    };

    return (
      <WizCard  className="wizModalUserIdentityShow-card">
        <Table className="table-style-class" key={'table@'+this.state.personId} rowKey={record => record.id} {...dataTableProps}/>
      </WizCard>
    )
  };

  _render() {
    const {certLinkLoading} = this.props;
    let {title, width} = this.props;
    return (
      <WizModal
        key={this.personId + '@' + this.state.time}
        visible={this.state.modalVisible}
        title={title || '查看任职'}
        width={width || 950}
        onCancel={e => this._onCancel(e)}
        footer={false}
      >
        <WizSpin tip={'加载中'} spinning={certLinkLoading}>
          {this._userBaseInfo()}
          {this._userIdentityInfo()}
          <div style={{textAlign:'center'}}>
        <WizButton type="primary" style={{ marginRight: 20 }} onClick={this._onOk.bind(this)}>保存</WizButton>
        <WizButton  style={{ marginLeft: 40 }} onClick={this._onCancel.bind(this)}>关闭</WizButton>
        </div>
        </WizSpin>
      </WizModal>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  const {certLink} = state;
  const personAndUserIdentitiesInfo = modelUtils.getModelEntity(certLink, "getList@" + ownProps.personId);
  const updateOrg = modelUtils.getModelEntity(certLink, "updateOrg@");
  const load = modelUtils.getLoadingState(state, ['certLink']);
  return {
    personAndUserIdentitiesInfo: personAndUserIdentitiesInfo,
    updateOrg: updateOrg,
    ...load
  }
};
export default connect(mapStateToProps)(SelectLinkOrg);
